import React from 'react';

export const QobuzIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      fill="currentColor"
      d="M12 2a10 10 0 1 0 6.93 17.2l2.28 2.28 1.42-1.42-2.28-2.28A10 10 0 0 0 12 2zm0 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16z"
    />
    <path
      fill="currentColor"
      d="M12 7.2a4.8 4.8 0 1 0 2.95 8.58l1.03 1.03 1.2-1.2-1.03-1.03A4.8 4.8 0 0 0 12 7.2zm0 1.8a3 3 0 1 1 0 6 3 3 0 0 1 0-6z"
    />
  </svg>
);

export const EllaRadioIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <rect x="2" y="8" width="2.5" height="8" rx="1.25" fill="#C9A84C" opacity="0.6">
      <animate attributeName="height" values="8;14;8" dur="1.2s" repeatCount="indefinite" />
      <animate attributeName="y" values="8;5;8" dur="1.2s" repeatCount="indefinite" />
    </rect>
    <rect x="6.5" y="5" width="2.5" height="14" rx="1.25" fill="#C9A84C" opacity="0.8">
      <animate attributeName="height" values="14;6;14" dur="1s" repeatCount="indefinite" />
      <animate attributeName="y" values="5;9;5" dur="1s" repeatCount="indefinite" />
    </rect>
    <rect x="11" y="3" width="2.5" height="18" rx="1.25" fill="#C9A84C">
      <animate attributeName="height" values="18;10;18" dur="1.4s" repeatCount="indefinite" />
      <animate attributeName="y" values="3;7;3" dur="1.4s" repeatCount="indefinite" />
    </rect>
    <rect x="15.5" y="6" width="2.5" height="12" rx="1.25" fill="#C9A84C" opacity="0.8">
      <animate attributeName="height" values="12;16;12" dur="1.1s" repeatCount="indefinite" />
      <animate attributeName="y" values="6;4;6" dur="1.1s" repeatCount="indefinite" />
    </rect>
    <rect x="20" y="9" width="2.5" height="6" rx="1.25" fill="#C9A84C" opacity="0.6">
      <animate attributeName="height" values="6;12;6" dur="0.9s" repeatCount="indefinite" />
      <animate attributeName="y" values="9;6;9" dur="0.9s" repeatCount="indefinite" />
    </rect>
  </svg>
);

export const GramophoneIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
    <path
      fill="currentColor"
      d="M9.2 6.4c2.2-1.9 5.2-2.4 7.6-1.2 1.6.8 2.3 2.2 1.8 3.7-.6 1.8-2.7 3-5.2 3.2l-2 .1 1.5 1.2c.7.6.9 1.6.4 2.4-.5.8-1.5 1-2.3.6l-4-2.5c-.5-.3-.8-.8-.9-1.4-.1-.6.2-1.1.6-1.5l2.5-2.2zm2.2 12.6h7.1c1 0 1.8.8 1.8 1.8v.2H3.7v-.2c0-1 .8-1.8 1.8-1.8h2.3l.7-1.6h2.5l.4 1.6z"
    />
    <path
      fill="currentColor"
      d="M7.5 14.5c-.5-.3-.6-1-.1-1.4l1.2-1c.4-.3 1-.3 1.3.1.3.4.3 1-.1 1.3l-1 .8 2.9 1.8c.4.2.5.7.3 1.1-.2.4-.7.5-1.1.3l-3.4-2z"
      opacity="0.35"
    />
  </svg>
);

